module.exports = __webpack_public_path__ + "assets/img/index-box2-0.2e84fb2d.png";